/* import __COLOCATED_TEMPLATE__ from './error-card.hbs'; */
import Component from '@glimmer/component';
export default class BankingLaunchpadErrorCard extends Component {}